export default {"src":"/_next/static/media/twitter.0f57e856.svg","height":34,"width":34,"blurWidth":0,"blurHeight":0};